import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const InformacionContactoIcon = props => {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <SvgIcon {...props} viewBox="0 0 38.551 38.552">
      <g id="_001-resume" data-name="001-resume" transform="translate(0)">
        <g id="Grupo_264" data-name="Grupo 264" transform="translate(0)">
          <g id="Grupo_263" data-name="Grupo 263" transform="translate(0)">
            <path
              id="Trazado_87"
              data-name="Trazado 87"
              d="M31.18,11.2a.753.753,0,0,0,.753-.753V2.259A2.261,2.261,0,0,0,29.674,0H2.266A2.261,2.261,0,0,0,.007,2.259V36.294a2.261,2.261,0,0,0,2.259,2.259H29.674a2.261,2.261,0,0,0,2.259-2.259V30.746a.753.753,0,1,0-1.506,0v5.547a.754.754,0,0,1-.753.753H2.266a.754.754,0,0,1-.753-.753V2.259a.754.754,0,0,1,.753-.753H29.674a.754.754,0,0,1,.753.753v8.189A.753.753,0,0,0,31.18,11.2Z"
              transform="translate(-0.007)"
            />
          </g>
        </g>
        <g
          id="Grupo_266"
          data-name="Grupo 266"
          transform="translate(9.036 4.066)"
        >
          <g id="Grupo_265" data-name="Grupo 265">
            <path
              id="Trazado_88"
              data-name="Trazado 88"
              d="M126.934,54a6.924,6.924,0,0,0-4.753,11.962.745.745,0,0,0,.081.075,6.914,6.914,0,0,0,9.343,0,.753.753,0,0,0,.081-.075A6.924,6.924,0,0,0,126.934,54Zm0,12.349a5.392,5.392,0,0,1-3.275-1.1,3.765,3.765,0,0,1,6.55,0A5.392,5.392,0,0,1,126.934,66.349Zm-1.2-5.723v-.489a1.2,1.2,0,1,1,2.41,0v.489a1.2,1.2,0,1,1-2.41,0Zm5.568,3.515a5.224,5.224,0,0,0-2.218-1.86,2.7,2.7,0,0,0,.566-1.656v-.489a2.711,2.711,0,1,0-5.421,0v.489a2.7,2.7,0,0,0,.566,1.656,5.224,5.224,0,0,0-2.218,1.86,5.421,5.421,0,1,1,8.725,0Z"
              transform="translate(-120.007 -54)"
            />
          </g>
        </g>
        <g
          id="Grupo_268"
          data-name="Grupo 268"
          transform="translate(15.21 32.98)"
        >
          <g id="Grupo_267" data-name="Grupo 267">
            <path
              id="Trazado_89"
              data-name="Trazado 89"
              d="M206.826,438H202.76a.753.753,0,1,0,0,1.506h4.066a.753.753,0,0,0,0-1.506Z"
              transform="translate(-202.007 -438)"
            />
          </g>
        </g>
        <g
          id="Grupo_270"
          data-name="Grupo 270"
          transform="translate(8.584 28.764)"
        >
          <g id="Grupo_269" data-name="Grupo 269">
            <path
              id="Trazado_90"
              data-name="Trazado 90"
              d="M125.452,382H114.76a.753.753,0,1,0,0,1.506h10.692a.753.753,0,1,0,0-1.506Z"
              transform="translate(-114.007 -382)"
            />
          </g>
        </g>
        <g
          id="Grupo_272"
          data-name="Grupo 272"
          transform="translate(8.584 24.547)"
        >
          <g id="Grupo_271" data-name="Grupo 271">
            <path
              id="Trazado_91"
              data-name="Trazado 91"
              d="M125.452,326H114.76a.753.753,0,1,0,0,1.506h10.692a.753.753,0,1,0,0-1.506Z"
              transform="translate(-114.007 -326)"
            />
          </g>
        </g>
        <g
          id="Grupo_274"
          data-name="Grupo 274"
          transform="translate(5.367 20.33)"
        >
          <g id="Grupo_273" data-name="Grupo 273">
            <path
              id="Trazado_92"
              data-name="Trazado 92"
              d="M72.573,270.221a.752.752,0,1,0,.221.532A.759.759,0,0,0,72.573,270.221Z"
              transform="translate(-71.287 -270)"
            />
          </g>
        </g>
        <g
          id="Grupo_276"
          data-name="Grupo 276"
          transform="translate(5.367 24.547)"
        >
          <g id="Grupo_275" data-name="Grupo 275">
            <path
              id="Trazado_93"
              data-name="Trazado 93"
              d="M72.573,326.221a.752.752,0,1,0,.221.532A.76.76,0,0,0,72.573,326.221Z"
              transform="translate(-71.287 -326)"
            />
          </g>
        </g>
        <g
          id="Grupo_278"
          data-name="Grupo 278"
          transform="translate(5.367 28.764)"
        >
          <g id="Grupo_277" data-name="Grupo 277">
            <path
              id="Trazado_94"
              data-name="Trazado 94"
              d="M72.573,382.221a.752.752,0,1,0,.221.532A.76.76,0,0,0,72.573,382.221Z"
              transform="translate(-71.287 -382)"
            />
          </g>
        </g>
        <g
          id="Grupo_280"
          data-name="Grupo 280"
          transform="translate(8.584 20.33)"
        >
          <g id="Grupo_279" data-name="Grupo 279">
            <path
              id="Trazado_95"
              data-name="Trazado 95"
              d="M125.452,270H114.76a.753.753,0,1,0,0,1.506h10.692a.753.753,0,1,0,0-1.506Z"
              transform="translate(-114.007 -270)"
            />
          </g>
        </g>
        <g
          id="Grupo_282"
          data-name="Grupo 282"
          transform="translate(22.407 9.388)"
        >
          <g id="Grupo_281" data-name="Grupo 281">
            <path
              id="Trazado_96"
              data-name="Trazado 96"
              d="M312.153,125.1a3.162,3.162,0,0,0-4.32,1.158l-9.476,16.412a.754.754,0,0,0-.1.293l-.667,5.974a.753.753,0,0,0,1.195.69l4.84-3.565a.751.751,0,0,0,.206-.23l9.476-16.412A3.166,3.166,0,0,0,312.153,125.1Zm-12.871,22.294.348-3.12,2.179,1.258Zm3.626-2.967-2.869-1.657,7.6-13.17,2.869,1.657Zm9.1-15.76-.742,1.286-2.869-1.657.742-1.286a1.657,1.657,0,0,1,2.869,1.657Z"
              transform="translate(-297.589 -124.675)"
            />
          </g>
        </g>
      </g>
    </SvgIcon>
  );
};

export default InformacionContactoIcon;
